const createDeviceDialogSx = {
  dialogPaper: {
    minWidth: '500px',
    maxHeight: '80vh',
  },
  dialogContent: {
    pt: 2,
  },
  dialogActions: {
    px: 3,
    pb: 2,
  },
  fieldLabel: {
    display: 'block',
    marginBottom: '8px',
    fontSize: '0.875rem',
    fontWeight: 500,
    color: 'white',
  },
  deviceTypeField: {
    '& .MuiInputLabel-root': {
      display: 'none',
    },
    '& .MuiSelect-select': {
      paddingTop: '8.5px',
      paddingBottom: '8.5px',
      color: 'inherit',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      '& legend': {
        display: 'none',
      },
    },
    '& .MuiPaper-root': {
      zIndex: 9999,
      marginTop: '4px',
    },
    '& .MuiMenu-paper': {
      zIndex: 9999,
      marginTop: '4px',
      '& .MuiMenuItem-root': {
        color: 'text.primary',
        '&:hover': {
          backgroundColor: 'action.hover',
          color: 'text.primary',
        },
        '&.Mui-selected': {
          backgroundColor: 'action.selected',
          color: 'text.primary',
          '&:hover': {
            backgroundColor: 'action.selected',
            color: 'text.primary',
          },
        },
      },
    },
  },
  parentDeviceField: {
    '& .MuiInputLabel-root': {
      display: 'none',
    },
    '& .MuiSelect-select': {
      paddingTop: '8.5px',
      paddingBottom: '8.5px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      '& legend': {
        display: 'none',
      },
    },
    '& .MuiPaper-root': {
      zIndex: 9999,
      marginTop: '4px',
    },
    '& .MuiMenu-paper': {
      zIndex: 9999,
      marginTop: '4px',
    },
    '&.Mui-disabled': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.23)',
      },
    },
  },
  textField: {
    '& .MuiInputLabel-root': {
      display: 'none',
    },
    '& .MuiOutlinedInput-input': {
      paddingTop: '8.5px',
      paddingBottom: '8.5px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      '& legend': {
        display: 'none',
      },
    },
  },
};

export default createDeviceDialogSx;
